import { isRecord } from '@/helpers/isRecord'
import { FetchResourceCollectionOK } from '@/japi/types/FetchResourceCollectionOK'
import { Resource } from '@/japi/types/Resource'

import { isErrorDocument } from './isErrorDocument'

export const isResourceCollectionDocument = <R extends Resource>(japiDocument: unknown): japiDocument is FetchResourceCollectionOK<R> => isRecord(japiDocument) && ! isErrorDocument(japiDocument) && Array.isArray(japiDocument.data)
